// extracted by mini-css-extract-plugin
export var chip = "_5l-9";
export var chipLabel = "_5l-a";
export var close = "_5l-7";
export var closeIcon = "_5l-8";
export var error = "_5l-6";
export var infoTooltip = "_5l-2";
export var innerContainer = "_5l-1";
export var input = "_5l-b";
export var medium = "_5l-5";
export var outerContainer = "_5l-0";
export var small = "_5l-4";
export var xSmall = "_5l-3";